import * as React from 'react';

export interface PartnershipIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * PartnershipIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description General or limited partnership. Signed partnership agreement document with two signature lines and wax seal.
 */
const PartnershipIcon: React.FunctionComponent<PartnershipIconProps> = ({
  className,
  size = 40,
  title = 'Partnership',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <path d="M10 4 Q10 3 11 3 L32 3 L40 11 L40 43 Q40 44 39 44 L11 44 Q10 44 10 43 Z" fill="#FFFFFF" stroke="#3a4a5c" strokeWidth="1.4"/>
      <path d="M32 3 L32 11 L40 11 Z" fill="#3a4a5c"/>
      <text x="25" y="22" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="6" fontWeight="900" fill="#3a4a5c" letterSpacing="0.4">PARTNER</text>
      <line x1="14" y1="27" x2="36" y2="27" stroke="#3a4a5c" strokeWidth="0.7"/>
      <line x1="14" y1="30" x2="32" y2="30" stroke="#3a4a5c" strokeWidth="0.7"/>
      <line x1="14" y1="36" x2="22" y2="36" stroke="#3a4a5c" strokeWidth="0.8"/>
      <text x="14" y="35" fontFamily="cursive" fontSize="4" fontWeight="700" fill="#a32d4a">X</text>
      <line x1="26" y1="36" x2="36" y2="36" stroke="#3a4a5c" strokeWidth="0.8"/>
      <text x="26" y="35" fontFamily="cursive" fontSize="4" fontWeight="700" fill="#a32d4a">X</text>
      <circle cx="34" cy="41" r="2.5" fill="#a32d4a"/>
      <path d="M34 39.5 L34.4 40.4 L35.3 40.5 L34.6 41.1 L34.8 42 L34 41.5 L33.2 42 L33.4 41.1 L32.7 40.5 L33.6 40.4 Z" fill="#FFFFFF"/>
  </svg>
);

export default PartnershipIcon;
